import { definePlugin, defineAIActions } from '@kernel/core/plugin-loader';

const aiActions = defineAIActions({
  namespace: 'cluster',
  actions: [
    {
      id: 'health-check',
      name: '健康检查',
      description: '检查集群中所有账号的健康状态',
      parameters: [
        { name: 'clusterId', type: 'number', description: '集群ID', required: false },
      ],
      handler: async (params) => {
        return {
          type: 'report',
          data: { healthy: 25, warning: 2, critical: 1 },
          message: '健康检查完成：25个正常，2个警告，1个严重',
        };
      },
    },
    {
      id: 'risk-analysis',
      name: '风险分析',
      description: '分析集群潜在风险',
      parameters: [],
      handler: async () => {
        return {
          type: 'table',
          data: [
            { risk: '账号被限流', level: '中', count: 2 },
            { risk: '登录状态失效', level: '高', count: 1 },
          ],
          message: '发现3个风险点需要关注',
        };
      },
    },
  ],
});

export default definePlugin({
  meta: {
    name: 'cluster-manager',
    version: '1.0.0',
    displayName: '集群管理',
    description: '多账号集群管理、任务队列、风险监控',
    icon: 'server',
    category: 'operations',
  },

  onLoad: async () => {
    console.log('[Plugin] Cluster Manager loaded');
  },

  onUnload: () => {
    console.log('[Plugin] Cluster Manager unloaded');
  },

  routes: [
    {
      path: '/clusters',
      lazy: async () => {
        const { ClusterDashboard } = await import('./pages/ClusterDashboard');
        return { Component: ClusterDashboard };
      },
    },
    {
      path: '/clusters/new',
      lazy: async () => {
        const { ClusterCreate } = await import('./pages/ClusterCreate');
        return { Component: ClusterCreate };
      },
    },
    {
      path: '/clusters/:id',
      lazy: async () => {
        const { ClusterDetail } = await import('./pages/ClusterDetail');
        return { Component: ClusterDetail };
      },
    },
    {
      path: '/clusters/tasks',
      lazy: async () => {
        const { TaskQueue } = await import('./pages/TaskQueue');
        return { Component: TaskQueue };
      },
    },
    {
      path: '/clusters/monitoring',
      lazy: async () => {
        const { MonitoringCenter } = await import('./pages/MonitoringCenter');
        return { Component: MonitoringCenter };
      },
    },
  ],

  sidebarMenus: [
    {
      id: 'clusters',
      title: '集群管理',
      icon: 'server',
      path: '/clusters',
      order: 4,
    },
  ],

  aiActions,
});

